module.exports = __webpack_public_path__ + "img/horizontal_3_4_r_pp2_8011.9a539a0f.png";